import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUpIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-white mt-auto" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-56">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-57">
          <div className="col-span-1 md:col-span-2" data-id="element-58">
            <div className="flex items-center gap-2 mb-4" data-id="element-59">
              <TrendingUpIcon className="text-blue-400" size={28} data-id="element-60" />
              <span className="text-xl font-bold" data-id="element-61">CryptoTopReviews</span>
            </div>
            <p className="text-slate-400 mb-4" data-id="element-62">
              Your trusted source for cryptocurrency reviews, ratings, and
              market intelligence.
            </p>
          </div>

          <div data-id="element-63">
            <h3 className="font-semibold mb-4" data-id="element-64">Quick Links</h3>
            <ul className="space-y-2" data-id="element-65">
              <li data-id="element-66">
                <Link to="/cryptocurrencies" className="text-slate-400 hover:text-white transition-colors" data-id="element-67">
                  Cryptocurrencies
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/exchanges" className="text-slate-400 hover:text-white transition-colors" data-id="element-69">
                  Exchanges
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/opportunities" className="text-slate-400 hover:text-white transition-colors" data-id="element-71">
                  Opportunities
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/social-media" className="text-slate-400 hover:text-white transition-colors" data-id="element-73">
                  Social Media
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-74">
            <h3 className="font-semibold mb-4" data-id="element-75">Legal</h3>
            <ul className="space-y-2" data-id="element-76">
              <li data-id="element-77">
                <Link to="/terms-of-use" className="text-slate-400 hover:text-white transition-colors" data-id="element-78">
                  Terms of Use
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center" data-id="element-79">
          <p className="text-slate-400 text-sm" data-id="element-80">
            © {new Date().getFullYear()} CryptoTopReviews. All rights reserved.
          </p>
          <p className="text-slate-500 text-xs mt-2" data-id="element-81">
            <Link to="/terms-of-use" className="text-blue-400 hover:text-blue-300 font-semibold" data-id="element-82">
              Terms of Use & Disclaimer
            </Link>
          </p>
        </div>
      </div>
    </footer>;
}